import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from './admin-services/auth.service';
@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private authService: AuthService, private router: Router) { }

    // : Observable<boolean> | Promise<boolean> | boolean
    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const url: string = state.url;
        return this.checkAuth(url);
    }

    private checkAuth(url) {
        if (this.authService.isAunthenticated()) { return true; }
        // Store the attempted URL for redirecting
        this.authService.redirectUrl = url;
        this.router.navigate(['./login']);
        return false;
    }

    canActivateChild(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): boolean {
        const url: string = state.url;
        if (this.authService.authComponent(url)) {
            return true;
        }

        this.router.navigate(['admin/dashboard']);
        return false;
    }

}



// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/app/feature-modules/admin/auth-gaurd.ts